module.exports = __webpack_public_path__ + "static/img/16.b862fc50.jpg";